<template>
  <div>
    <Header :home="false" :logged="true" :arealogada="true"/>

    <div id="painel" class="container-fluid">
      <b-row>
        <b-col cols="12" md="4" lg="3" style="padding: 0;" class="espaco-menu">
          <Menu class="d-none d-xl-block" />
        </b-col>
        <b-col cols="12" md="8" lg="9" class="flex h-100 w-100 justify-content-center">
          <a style="display:block" :id="'download_boleto'" :download="'download_boleto'" />

          <b-container fluid id="painelcontainerfluid">
            <div class="row">
              <div class="col-12">
                <ul class="nav nav-tabs">
                  <li class="nav-item">
                    <a class="nav-link" v-bind:class="[panel == 1 ? 'active' : '']" href="#" @click="panel = 1">Pedidos cotados</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="#" v-bind:class="[panel == 2 ? 'active' : '']" @click="panel = 2">Pedidos aguardando pagamento</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="#" v-bind:class="[panel == 3 ? 'active' : '']" @click="panel = 3">Pedidos pagos</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="#" v-bind:class="[panel == 4 ? 'active' : '']" @click="panel = 4">Pedidos cancelados</a>
                  </li>
                </ul>
              </div>
              <div class="col-12 inner-content" v-if="panel == 1">
                <div id="wrapper-spinner" v-if="loading">
                  <BeatLoader color="var(--main-azul)" />
                </div>
                <table class="table table-striped">
                  <thead>
                    <tr class="table-resultado-header">
                      <td>Nº pedido</td>
                      <td>Documento</td>
                      <td>Tipo de pedido</td>
                      <td>Data do pedido</td>
                      <td>Orçamento</td>
                      <td>Ação</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="d in data">
                      <td>{{ d.cd_pedido }}</td>
                      <td>{{ d.documento_pedido }}</td>
                      <td>{{ d.nm_produto }}</td>
                      <td>{{ moment(d.data_pedido).format('DD/MM/YYYY') }}</td>
                      <td>{{ currencyFormatter.format(parseFloat(d.vl_orcamento)) }}</td>
                      <td>
                        <a style="cursor: pointer;" @click="addCart(d)" v-if="!isInCart(d.cd_pedido)"><font-awesome-icon icon="shopping-cart"></font-awesome-icon></a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="col-12 inner-content" v-if="panel >= 2">
                <table class="table table-striped">
                  <thead>
                    <tr class="table-resultado-header">
                      <td>Data do pedido</td>
                      <td>Orçamento</td>
                      <td>Itens</td>
                      <td>Chave</td>
                      <td>Ação</td>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="panel == 2">
                      <tr v-for="p in pedidos" v-if="p.pg_status == 0">
                        <td>{{ p.dtpedido }}</td>
                        <td>{{ currencyFormatter.format(parseFloat(p.vl_orcamento)) }}</td>
                        <td>{{ p.items }}</td>
                        <td>{{ p.chave }}</td>
                        <td>
                          <a style="cursor: pointer;" @click="checkout(p.chave)"><font-awesome-icon icon="eye"></font-awesome-icon></a>
                        </td>
                      </tr>
                    </template>
                    <template v-if="panel == 3">
                      <tr v-for="p in pedidos" v-if="p.pg_status == 1">
                        <td>{{ p.dtpedido }}</td>
                        <td>{{ currencyFormatter.format(parseFloat(p.vl_orcamento)) }}</td>
                        <td>{{ p.items }}</td>
                        <td>{{ p.chave }}</td>
                        <td>
                          <a style="cursor: pointer;" @click="detail(p.chave)"><font-awesome-icon icon="eye"></font-awesome-icon></a>
                        </td>
                      </tr>
                    </template>
                    <template v-if="panel == 2">
                      <tr v-for="p in pedidos" v-if="p.pg_status == 2">
                        <td>{{ p.dtpedido }}</td>
                        <td>{{ currencyFormatter.format(parseFloat(p.vl_orcamento)) }}</td>
                        <td>{{ p.items }}</td>
                        <td>{{ p.chave }}</td>
                        <td>
                          <a style="cursor: pointer;" @click="detail(p.chave)"><font-awesome-icon icon="eye"></font-awesome-icon></a>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </b-container>
        </b-col>
      </b-row>
    </div>
    <footersite class="d-none d-xl-block" />
    <footersitemobile class="d-block d-xl-none"/>
  </div>
</template>

<script>
import BeatLoader from 'vue-spinner/src/BeatLoader.vue'
import Header from '../components/Header'
import Estados from '../services/estados'
import API from '../services/api'
import footersite from "../components/footersite";
import footersitemobile from "../components/footersite/index_mobile";
import Menu from '../template/Menu'
import moment from 'moment'

export default {
  components: {
    Header,
    BeatLoader,
    footersite,
    footersitemobile,
    Menu,
  },
  data() {
    return {
      logged: true,
      loading: false,
      data: [],
      pedidos: [],
      panel: 1,
      currencyFormatter: new Intl.NumberFormat('pt-BR', {style: 'currency',currency: 'BRL'}),
      moment: moment,
    }
  },
  methods: {
    init() {
      this.loading = true;
        var token = localStorage.getItem('jwtToken');
        var url = `certidao/usuario?token=${token}&dini=&dfim=&dtSoli=&nmpesq=&docp=&st=2&tpPedido=1,2,3,4,5,6,7,8,9&nrPedido=&vl_titulo=&vl_saldo=&primeiraBusca=false`;
        API.get(url).then((res) => {
          this.data = res.data
          this.loading = false;
        })
        API.get(`carrinho?token=${token}`).then((res) => {
          this.pedidos = res.data
        })
    },
    addCart(dados) {
      this.$store.commit('cart/add', {'cd_pedido': dados.cd_pedido, descricao: dados.nm_produto, valor: dados.vl_orcamento});
      if(this.$store.state.cart.success){
        this.$toasted.show('Pedido adicionado ao carrinho')
      } else {
        this.$toasted.show('O pedido já se encontra no carrinho')
      }
      
    },
    isInCart(pedido) {
      var r = false;
      var items = this.$store.state.cart.item;
      items.forEach((row) => {
        console.log(row.cd_pedido + ' - ' + pedido)
        if(parseInt(row.cd_pedido) == pedido)
          r = true;
      })
      return r;
    },
    checkout(chave){
      this.$router.push({path: `/checkout/${chave}`});
    }
  },
  created() {
    this.init();
  }
}

</script>

<style>
#wrapper-spinner {
  position: fixed;
  width: 96%;
  left: 0px;
  bottom: 0px;
  padding-top: 30px;
  height: calc(100% - 80px);
}
#wrapper-spinner .v-spinner {
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -10px 0px 0px -20px;
}
#painel {
  position: fixed;
  width: 100%;
  left: 0px;
  bottom: 0px;
  padding-top: 0px;
  height: calc(100% - 80px);
  background-color: #ffffff;
  overflow-x: hidden;
    border-top: 1px solid #f1f1f1;
}
.inner-content {
  border: 1px solid #CCC;
}
.table-resultado-header {
    color: white;
    font-weight: bold;
    background-color: #597eb5;
}
</style>